import React, { useState, useEffect } from 'react';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import PropTypes from 'prop-types';
import { Button } from '@uhg-abyss/web/ui/Button';
import { styled } from '@uhg-abyss/web/tools/styled';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import {
  resetDeleteSecretAPI,
  useDeleteSecretAPI,
} from '@src/hooks/useDeleteSecretAPI';
import { useGetCredentials } from '@src/hooks/useGetCredentials';
import { useSelector } from 'react-redux';

const SubmitButton = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '15px',
  marginBottom: '15px',
});

export const ConfirmationModal = ({
  isOpen,
  isClosed,
  title,
  handleConfirmModal,
  deletePayloadObj,
}) => {
  const [deleteValue, setDeleteValue] = React.useState('');
  const [isDeleteEnabled, setIsDeleteEnabled] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteSecretApi, callDeleteSecretApi] = useDeleteSecretAPI();
  const [, resetDeleteSecretAPICall] = resetDeleteSecretAPI();
  const [, fetchCredentials] = useGetCredentials();
  const userInfo = useSelector((state) => {
    return state.GET_USER_INFO.data;
  });
  const dsUserInfo = useSelector((state) => {
    return state.GET_DS_USER_INFO.data;
  });
  const orgId = dsUserInfo?.orgId;

  const handleInputChange = (e) => {
    const value = e.target.value;
    setDeleteValue(value);
    setIsDeleteEnabled(value === 'delete');
  };

  const deleteSecret = () => {
    setIsLoading(true);
    callDeleteSecretApi(deletePayloadObj);
  };

  useEffect(() => {
    if (deleteSecretApi.error) {
      setIsLoading(false);
    }

    if (deleteSecretApi.success) {
      resetDeleteSecretAPICall();
      fetchCredentials({ userInfo, orgId });
    }
  }, [deleteSecretApi]);

  return (
    <Modal
      title={title}
      isOpen={isOpen}
      onClose={handleConfirmModal}
      css={{
        'abyss-modal-header-container': {
          color: '#002677',
          fontSize: '28.83px',
        },
        'abyss-modal-content-title': { 'font-size': '26px !important' },
      }}
    >
      <Modal.Section>
        <div>
          <p>
            {' '}
            This action <b>cannot be undone</b>. Be sure to notify your users
            about this change.
          </p>
          <TextInput
            id="deleteConfirmationInput"
            type="text"
            label='Please type the word "delete" to confirm.'
            width="40%"
            validators={{ required: true }}
            value={deleteValue}
            onChange={handleInputChange}
            css={{
              'abyss-text-input-label': {
                position: 'relative',
                fontSize: '15px',
              },
            }}
          />
        </div>
        <SubmitButton>
          <Button
            id="cancelButton"
            variant="outline"
            fontSize="15px"
            size="$md"
            marginRight="30px !important"
            onClick={handleConfirmModal}
          >
            Close
          </Button>
          <Button
            id="submitButton"
            fontSize="15px"
            size="$md"
            disabled={!isDeleteEnabled}
            onClick={deleteSecret}
            isLoading={isLoading}
            ariaLoadingLabel="Deleting Secret"
          >
            Delete Secret
          </Button>
        </SubmitButton>
      </Modal.Section>
    </Modal>
  );
};
ConfirmationModal.propTypes = {
  isClosed: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  handleConfirmModal: PropTypes.func.isRequired,
  deletePayloadObj: PropTypes.object.isRequired,
};
